/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Button, Input } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { GetAllSellingStockList } from "../../utilities/api/stock/sell";
import { GetAllRentingStockList } from "../../utilities/api/stock/rent";
import { emailValidation, nameValidation } from "../../utilities/utils";
import { toast } from "react-toastify";
import {
  CreatePosOrder,
  GetOrderAmount,
  ValidateOrderUser,
} from "../../utilities/api/pos";
import { SellingOrder } from "./SellingOrder";
import { RentingOrder } from "./RentingOrder";
import { SellingProduct } from "./SellingProduct";
import { RentingProduct } from "./RentingProduct";
import { ConfirmBillModal } from "./ConfirmBillModal";
import { SoldProductList } from "./SoldProductList";
import { RentedProductList } from "./RentedProductList";
import { AllRentedOrderList } from "../../redux/Slice/Pos/RentedOrderListSlice";
import { AllSoldOrderList } from "../../redux/Slice/Pos/SoldOrderListSlice";
import { GetEnumsArr } from "../../redux/Slice/Users/EnumsSclice";
import { GetStates } from "../../redux/Slice/Users/StateListSlice";
import { messages } from "../../utilities/Messages";

const getMessage = messages.posAdmin;

const PosAdminDashboard = () => {
  const dispatch = useAppDispatch();
  const { UserFacilities } = useAppSelector((state) => state.verifiedUser);
  const [sellData, setSellData] = useState<any>([]);
  const [rentData, setRentData] = useState<any[]>([]);
  const [selectedStock, setSelectedStock] = useState("sold");
  const [sellingProducts, setSellingProducts] = useState({}) as any;
  const [productQuantity, setProductQuantity] = useState({}) as any;
  const [currentProductQuantity, setCurrentProductQuantity] = useState(
    {}
  ) as any;
  const [show, setShow] = useState(false);
  const [rentProductQuantity, setRentProductQuantity] = useState({}) as any;
  const [currentRentProductQuantity, setRentCurrentProductQuantity] = useState(
    {}
  ) as any;
  const [rentingProducts, setRentingProducts] = useState([
    {
      id: 1,
      selectedQuantity: 0,
      duration: 30,
      name: "",
      rentingPrice: 0,
      availableQuantity: 0,
      startTime: "00:00",
    },
  ]);
  const [amount, setAmount] = useState({
    discount: 0,
    subTotal: 0,
    totalAmount: 0,
    totalTax: 0,
  });
  const [verifyStatus, setVerifyStatus] = useState(false)
  const [isIgstTax, setIsIgstTax] = useState(false);
  const [isPaymentCollected, setIsPaymentCollected] = useState(false);
  const facilityId = UserFacilities[0]?.facility.id;
  const initialData = {
    facilityId: facilityId,
    sellingProducts: [],
    rentingProducts: [],
    isIgstTax: `${isIgstTax}`,
    phone: "",
    firstName: "",
    lastName: "",
    companyName: "",
    gstNumber: "",
    gender: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    landmark: "",
    latitude: null,
    longitude: null,
  };
  const initialError = {
    phone: "",
    firstName: "",
    lastName: "",
    gstNumber: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    email: "",
  };
  const [data, setData] = useState(initialData);
  const [isVerified, setIsVerified] = useState(initialData);
  const [errorMessage, setErrorMessage] = useState(initialError);
  const [printing, setPrinting] = useState(false);

  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const minutes = ["00", "30"];
  const TimeArray = hours.flatMap((hour) =>
    minutes.map((minute) => `${hour}:${minute}`)
  );

  const GetData = async (value: any = "all") => {
    if (value == "sell" || value == "all") {
      const sellApi = await GetAllSellingStockList(facilityId, "true");
      if (sellApi.statusCode === 200) {
        const _sellData = sellApi.data.rows?.reduce?.(
          (_result: any, _row: any) => {
            _result[_row?.id] = _row;
            return _result;
          },
          {}
        );
        setSellData(_sellData);

        const _sellProducts = sellApi.data.rows.reduce(
          (_result: any, item: any) => {
            _result[item?.id] = {
              id: item?.id,
              name: item?.name,
              sellingPrice: item?.sellingPrice,
              availableQuantity: item?.availableQuantity,
              selectedQuantity: 0,
            };
            setProductQuantity((old: any) => ({ ...old, [item?.id]: 0 }));
            return _result;
          },
          {}
        );
        setSellingProducts(_sellProducts);
      } else {
        toast.error(sellApi.response.data.message);
      }
    }

    if (value == "rent" || value == "all") {
      const rentApi = await GetAllRentingStockList(facilityId, "true");
      if (rentApi.statusCode === 200) {
        setRentData(rentApi.data.rows);
        const rentProductId = rentApi.data.rows.map((item: any) => {
          setRentProductQuantity((old: any) => ({ ...old, [item?.id]: 0 }));
          return {
            id: item?.id,
            name: item?.name,
            rentingPrice: item?.rentingPrice,
            duration: 30,
            availableQuantity: item.availableQuantity,
            selectedQuantity: 0,
            startTime: startTime()[0],
          };
        });
        setRentingProducts(rentProductId);
      } else {
        toast.error(rentApi.response.data.message);
      }
    }
  };

  useEffect(() => {
    dispatch(GetEnumsArr());
    dispatch(GetStates());
    GetData();
    document.body.classList.add("pos-page");
    return () => {
      document.body.classList.remove("pos-page");
    };
  }, []);

  useEffect(() => {
    const _currentProductQuantity = Object.values(sellingProducts)?.reduce(
      (_result: any, item: any) => {
        _result[item?.id] = item?.selectedQuantity;
        return _result;
      },
      {}
    );
    setCurrentProductQuantity(_currentProductQuantity);

  }, [sellingProducts]);

  useEffect(() => {
    const _currentProductQuantity = rentingProducts?.reduce(
      (_result: any, item: any) => {
        _result[item?.id] = item?.selectedQuantity;
        return _result;
      },
      {}
    );
    setRentCurrentProductQuantity(_currentProductQuantity);

  }, [rentingProducts]);

  const GetAmount = async () => {
    let sendSellingFilter = Object.values(sellingProducts).filter(
      (item: any) => item.selectedQuantity > 0
    );
    let sendSellingProduct = sendSellingFilter.map((item: any) => ({
      id: item.id,
      quantity: item.selectedQuantity,
    }));
    let sendRentingFilter = rentingProducts.filter(
      (item: any) => item.selectedQuantity > 0
    );
    let sendRentingProduct = sendRentingFilter.map((item: any) => ({
      id: item.id,
      quantity: item.selectedQuantity,
      duration: item.duration,
      startTime: item.startTime,
    }));
    const payload = {
      facilityId: facilityId,
      sellingProducts: sendSellingProduct,
      rentingProducts: sendRentingProduct,
      isIgstTax: `${isIgstTax}`,
    };
    if (sendSellingProduct.length > 0 || sendRentingProduct.length > 0) {
      const result = await GetOrderAmount(payload);
      if (result.status === 200) {
        setAmount(result.data.data);
      }
    } else {
      setAmount({
        discount: 0,
        subTotal: 0,
        totalAmount: 0,
        totalTax: 0,
      });
    }
  };

  const GetUserDetail = async () => {
    const result = await ValidateOrderUser({ phone: data.phone });
    if (result.status === 200) {
      const _data = result.data.data;
      let AllData = {
        ...data,
        phone: _data.phone,
        firstName: _data.firstName,
        lastName: _data.lastName,
        companyName: _data?.companyName || "",
        gstNumber: _data?.gstNumber,
        gender: _data?.gender,
        email: _data?.email,
        addressLine1: _data.address.addressLine1,
        addressLine2: _data.address.addressLine2,
        city: _data.address.city,
        state: _data.address.state,
        country: _data.address.country,
        pincode: _data.address.pincode,
        landmark: _data.address.landmark,
      };
      setData(AllData);
      setIsVerified(AllData);
      setVerifyStatus(true);
    } else {
      setData({ ...initialData, phone: data.phone });
      setIsVerified({ ...initialData, phone: data.phone });
      toast.error(result.response.data.message);
    }
  };



  const hanldeCofirmBillPrint = async (submittedData?: any) => {
    setPrinting(true);
    const resolvedData = submittedData || data;
    let sendSellingFilter = Object.values(sellingProducts).filter(
      (item: any) => item.selectedQuantity > 0
    );
    let sendSellingProduct = sendSellingFilter.map((item: any) => ({
      id: item.id,
      quantity: item.selectedQuantity,
    }));
    let sendRentingFilter = rentingProducts.filter(
      (item: any) => item.selectedQuantity > 0
    );
    let sendRentingProduct = sendRentingFilter.map((item: any) => ({
      id: item.id,
      quantity: item.selectedQuantity,
      duration: item.duration,
      startTime: item.startTime,
    }));
    let payload = {
      facilityId: facilityId,
      sellingProducts: sendSellingProduct,
      rentingProducts: sendRentingProduct,
      isIgstTax: `${isIgstTax}`,
      phone: resolvedData.phone,
      firstName: resolvedData.firstName,
      lastName: resolvedData.lastName,
      companyName: resolvedData.companyName,
      gstNumber: resolvedData.gstNumber,
      gender: resolvedData.gender,
      email: resolvedData.email,
      addressLine1: resolvedData.addressLine1,
      addressLine2: resolvedData.addressLine2,
      city: resolvedData.city,
      state: resolvedData.state,
      country: resolvedData.country,
      pincode: resolvedData.pincode,
      landmark: resolvedData.landmark,
      latitude: null,
      longitude: null,
    };
    if (Validate()) {
      // console.log(payload, "payload");
      const result = await CreatePosOrder(payload);
      // console.log(result, "result");
      if (result.status === 200) {
        setVerifyStatus(false)
        setShow(false);
        setSellData([]);
        setRentData([]);
        setSelectedStock("sold");
        setSellingProducts({});
        setProductQuantity({});
        setCurrentProductQuantity({});
        setRentProductQuantity({});
        setRentCurrentProductQuantity({});
        setRentingProducts([
          {
            id: 0,
            selectedQuantity: 0,
            duration: 0,
            name: "",
            rentingPrice: 0,
            availableQuantity: 0,
            startTime: "",
          },
        ]);
        setAmount({
          discount: 0,
          subTotal: 0,
          totalAmount: 0,
          totalTax: 0,
        });
        setIsIgstTax(false);
        setIsPaymentCollected(false);
        setData(initialData);
        setIsVerified(initialData);
        GetData();
        GetInvoice(result.data.data.hash, result.data.data.id);
        RefreshList();
        setErrorMessage(initialError);
      } else {
        toast.error(result.response.data.message);
      }
    }
    setPrinting(false);
  };


  const Validate = () => {
    let emailValidationMessage = "";
    emailValidationMessage =
      data?.email != ""
        ? emailValidation(data?.email) == null
          ? getMessage.email_matches
          : ""
        : "";
    if (
      data.phone.length !== 10 ||
      data.firstName.length < 3 ||
      data.lastName.length <= 0 ||
      (data.gstNumber?.length && data.gstNumber.length < 10) ||
      emailValidationMessage != "" ||
      data.addressLine2.length > 50 ||
      data.landmark.length > 50
    ) {
      setErrorMessage({
        phone:
          data.phone.length !== 10 ? getMessage.phoneNumber_maxLength : "",
        firstName: data.firstName
          ? nameValidation(data.firstName) == null
            ? getMessage.firstName_matches
            : data.firstName.length > 30
              ? getMessage.firstName_maxLength
              : data.firstName.length < 3
                ? getMessage.firstName_minLength
                : ""
          : getMessage.firstName_required,
        lastName: data.lastName
          ? nameValidation(data.lastName) == null
            ? getMessage.lastName_matches
            : data.lastName.length > 30
              ? getMessage.lastName_maxLength
              : data.lastName.length < 3
                ? getMessage.lastName_minLength
                : ""
          : getMessage.lastName_required,

        gstNumber:
          data.gstNumber?.length &&
            data.gstNumber.length < 10 &&
            data.gstNumber.length > 10
            ? getMessage.gstnumber_length
            : "",

        addressLine1: data.addressLine1.length > 50? getMessage.addressLine1_maxLength : "",
        addressLine2:
          data.addressLine2.length > 50
            ? getMessage.addressLine2_maxLength
            : "",
        landmark:
          data.landmark.length > 50
            ? getMessage.landmark_maxLength
            : "",
        city: data.city.length > 50 ? getMessage.city_maxLength : "",
        state: data.state.length > 50 ? getMessage.state_maxLength : "",
        pincode: data.pincode.length > 6 ? getMessage.pincode_maxLength : "",
        email: emailValidationMessage,
      });
      return false;
    } else return true;
  };

  const GetInvoice = async (hash: string, id: any) => {
    window.open("/printing/?type=invoice&prefix=SS&id=" + id + "&hash=" + hash, "_blank");
  };

  const RefreshList = () => {
    dispatch(
      AllRentedOrderList({
        page: "1",
        facilityId: facilityId,
        key: "",
        fromDate: "",
        toDate: "",
      })
    );
    dispatch(
      AllSoldOrderList({
        page: "1",
        facilityId: facilityId,
        key: "",
        fromDate: "",
        toDate: "",
      })
    );
  };

  useEffect(() => {
    GetAmount();
  }, [rentingProducts, sellingProducts, isIgstTax]);

  useEffect(() => {
    if (data.phone.length === 10) GetUserDetail();
  }, [data.phone]);

  const changeHandler = (value: any) => {
    setSelectedStock(value);
    if (value == "sell" || value == "rent") {
      GetData(value);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateProductQuantityOnAction = (id: any) => {
    const quantity = Number(productQuantity[id]);
    let _product = sellingProducts[id] || {};
    if (quantity <= sellData[id]?.availableQuantity) {
      _product["availableQuantity"] =
        sellData[id]?.["availableQuantity"] - quantity;
      _product["selectedQuantity"] = quantity;
    }
    if (
      _product["availableQuantity"] + _product["selectedQuantity"] ===
      sellData?.[id]?.["availableQuantity"]
    ) {
      const _sellingProducts = { ...sellingProducts, [id]: _product };
      setSellingProducts(_sellingProducts);
    }
  };

  const handleRentDurationChange = (e: any, index: number) => {
    const changeDurationArray = rentingProducts.map((item: any, ind: any) =>
      index === ind ? { ...item, duration: Number(e.target.value) } : item
    );
    setRentingProducts(changeDurationArray);
  };

  const handleRentStartTimeChange = (e: any, index: number) => {
    const changeStartTimeArray = rentingProducts.map((item: any, ind: any) =>
      index === ind ? { ...item, startTime: e.target.value } : item
    );
    setRentingProducts(changeStartTimeArray);
  };

  const handleRentAdd = (id: number, index: number) => {
    let quantity = Number(rentProductQuantity[id]);

    let _product = rentingProducts[index];
    let listForAvailableSlots = startTime();

    if (listForAvailableSlots.indexOf(_product.startTime) > -1) {
      if (quantity <= rentData[index]?.availableQuantity) {
        _product["availableQuantity"] =
          rentData[index]?.availableQuantity - quantity;
        _product["selectedQuantity"] = quantity;
      }
      if (
        _product["availableQuantity"] + _product["selectedQuantity"] ===
        rentData?.[index]?.["availableQuantity"]
      ) {
        const _rentingProducts = rentingProducts.map((item: any, ind: any) =>
          index === ind ? _product : item
        );
        setRentingProducts(_rentingProducts);
      }
    } else {
      toast.error(getMessage.startDate_valid);
    }
  };

  const TotalSellingPrice = (totalFor: string) => {
    if (totalFor === "sell") {
      return Object.values(sellingProducts)?.length
        ? (Object.values(sellingProducts)?.reduce(
          (acc: any, cur: any) =>
            acc + cur?.selectedQuantity * cur?.sellingPrice,
          0
        ) as number)
        : 0;
    }
    if (totalFor === "rent") {
      return rentingProducts.length
        ? (rentingProducts.reduce(
          (acc: any, cur: any) =>
            acc +
            (cur.duration / 30) * cur.selectedQuantity * cur.rentingPrice,
          0
        ) as number)
        : 0;
    }
  };

  let startTime = () => {
    let date = new Date();
    let h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    let m =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

    let array = TimeArray.filter((item) => item > `${h}:${m}` && item);
    let beforeValue = TimeArray.indexOf(array[0]);
    let arrayToReturn = [TimeArray[beforeValue - 1], ...array];
    return arrayToReturn;
  };

  return (
    <>
      <Container fluid className="g-0">
        <div className="page-title align-items-center d-flex justify-content-between">
          <h3 className="mb-3 mt-3 text-start text-white">PoS System</h3>
          <ButtonGroup>
            <Button
              type="button"
              bname="Sales"
              onClick={() => changeHandler("sell")}
              className="btn btn-primary rounded-1 me-2"
              id="sell"
              name="sell"
            ></Button>
            <Button
              type="button"
              bname="Services"
              onClick={() => changeHandler("rent")}
              name="rent"
              id="rent"
              className="btn btn-primary rounded-1 me-2"
            ></Button>
          </ButtonGroup>
        </div>
        <div className="mb-3 text-start">
          <Form.Check
            className="text-white"
            inline
            label="Sales List"
            name="product"
            type="radio"
            id="sold"
            value="sold"
            checked={selectedStock === "sold"}
            onChange={(e: any) => changeHandler(e.target.value)}
          />
          <Form.Check
            className="text-white"
            inline
            label="Services List"
            name="product"
            type="radio"
            id="rented"
            value="rented"
            checked={selectedStock === "rented"}
            onChange={(e: any) => changeHandler(e.target.value)}
          />
        </div>
        <Row>
          <Col lg={12}>
            <span aria-hidden={selectedStock !== "sold" ? true : false}>
              <SoldProductList
                HandleDownload={GetInvoice}
                facilityId={facilityId}
              />
            </span>
            <span aria-hidden={selectedStock !== "rented" ? true : false}>
              <RentedProductList
                HandleDownload={GetInvoice}
                facilityId={facilityId}
              />
            </span>
          </Col>
          <Col lg={8}>
            <span aria-hidden={selectedStock !== "sell" ? true : false}>
              <Card>
                <Card.Body>
                  <div className="page-title align-items-center d-flex justify-content-between">
                    <Card.Title className="mb-0">Sales Product</Card.Title>
                  </div>
                  <hr />
                  <SellingProduct
                    sellData={sellData}
                    updateProductQuantityOnAction={
                      updateProductQuantityOnAction
                    }
                    sellingProducts={sellingProducts}
                    setProductQuantity={setProductQuantity}
                    productQuantity={productQuantity}
                  />
                </Card.Body>
              </Card>
            </span>
            <span aria-hidden={selectedStock !== "rent" ? true : false}>
              <Card>
                <Card.Body>
                  <div className="page-title align-items-center d-flex justify-content-between">
                    <Card.Title className="mb-0">Services Product</Card.Title>
                  </div>
                  <hr />
                  <RentingProduct
                    rentingProducts={rentingProducts}
                    handleRentDurationChange={handleRentDurationChange}
                    handleRentStartTimeChange={handleRentStartTimeChange}
                    startTime={startTime}
                    setRentProductQuantity={setRentProductQuantity}
                    rentProductQuantity={rentProductQuantity}
                    handleRentAdd={handleRentAdd}
                    rentData={rentData}
                  />
                </Card.Body>
              </Card>
            </span>
          </Col>
          <Col lg={4}>
            <span
              aria-hidden={
                ["sell", "rent"].includes(selectedStock) ? false : true
              }
            >
              <Card>
                <Card.Body>
                  <div className="page-title align-items-center d-flex justify-content-between">
                    <Card.Title className="mb-0">Current Order</Card.Title>
                  </div>

                  <h6 className="fw-semibold text-start">Sales Product</h6>
                  <table className="table align-middle">
                    <SellingOrder
                      sellingProducts={sellingProducts}
                      currentProductQuantity={currentProductQuantity}
                    />
                  </table>

                  <h6 className="fw-semibold text-start">Services Product</h6>
                  <table className="table align-middle table-borderless text-start">
                    <RentingOrder
                      rentingProducts={rentingProducts}
                      currentRentProductQuantity={currentRentProductQuantity}
                    />
                  </table>

                  <Card className="bg-light border-0 mb-3">
                    <Card.Body>
                      <div className="d-flex fw-semibold justify-content-between mb-2">
                        <span>Total Buying Charges</span>{" "}
                        <span>
                          <span className="rupees-symbol">&#8377;</span>{" "}
                          {TotalSellingPrice("sell")?.toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex fw-semibold justify-content-between mb-3">
                        <span>Total Service Charges</span>{" "}
                        <span>
                          <span className="rupees-symbol">&#8377;</span>{" "}
                          {TotalSellingPrice("rent")?.toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex fw-semibold justify-content-between mb-3">
                        <span>Total </span>{" "}
                        <span>
                          <span className="rupees-symbol">&#8377;</span>{" "}
                          {amount?.subTotal?.toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex fw-semibold justify-content-between mb-3">
                        <span>Total Tax</span>{" "}
                        <span>
                          <span className="rupees-symbol">&#8377;</span>{" "}
                          {amount?.totalTax?.toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex fw-bold justify-content-between mb-2">
                        <span>Total Amount</span>{" "}
                        <span>
                          <span className="rupees-symbol">&#8377;</span>{" "}
                          {Math.round(amount?.totalAmount)}
                        </span>
                      </div>
                      <div className="mt-3 text-start">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            name="igst"
                            id="igst"
                            checked={isIgstTax}
                            onChange={() => setIsIgstTax(!isIgstTax)}
                          />
                          <label className="form-check-label" htmlFor="igst">
                            IGST
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            className="form-check-input"
                            name="payment-collected"
                            id="payment-collected"
                            checked={isPaymentCollected}
                            onChange={() =>
                              setIsPaymentCollected(!isPaymentCollected)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="payment-collected"
                          >
                            Payment Collected
                          </label>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  <Button
                    disabled={!isPaymentCollected}
                    bname="Submit"
                    id="print-bill"
                    onClick={handleShow}
                    name="print-bill"
                    className="btn btn-lg btn-primary px-5 rounded"
                  ></Button>
                </Card.Body>
              </Card>
            </span>
          </Col>
        </Row>
      </Container>
      <ConfirmBillModal
        printing={printing}
        show={show}
        handleClose={handleClose}
        data={data}
        setData={setData}
        errorMessage={errorMessage}
        hanldeCofirmBillPrint={hanldeCofirmBillPrint}
        isVerified={isVerified}
        setIsVerified={setIsVerified}
        Validate={() => Validate()}
        verifyStatus={verifyStatus}
      />
    </>
  );
};
export { PosAdminDashboard };
